import React, { Component } from 'react';

class ErreurTermine extends Component {
    render() {
        return (
            <div className="page-erreur" dangerouslySetInnerHTML={{__html: this.props.config[`MES_FERM_${this.props.lang}`]}} />
        );
    }
}

export default ErreurTermine;